import styled from 'styled-components/macro'

export const Container = styled.div`
  position: relative;
  margin: 3.2rem auto;
  padding: 1.6rem;
  width: 100%;
  max-width: 64.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const PaymentSelectorWrap = styled.div`
  margin: 0 auto;
  padding: 0;
  width: 100%;
  max-width: 32rem;
`

export const Title = styled.h1`
  margin: 0 0 1.6rem;
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: 2.4rem;
  line-height: 1.44;
  text-align: center;
  color: ${(props) => props.theme.color.text};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    margin: 0 0 3.2rem;
    font-size: 3.2rem;
  `};
`

export const PreTitle = styled.h4`
  margin: 0 0 0.6rem;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.6rem;
  line-height: 1.33;
  text-align: center;
  color: ${(props) => props.theme.color.text};
  a {
    color: ${(props) => props.theme.color.default};
  }
`

export const IconWrap = styled.div`
  margin: 0 0 3.2rem;
  display: flex;
  width: 10rem;
  color: ${(props) => props.theme.color.darkBg};
`

export const SelectButtonTitle = styled.h5`
  margin: 0;
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: 1.8rem;
  line-height: 1.43;
  color: ${(props) => props.theme.color.text};
`

export const LoaderWrap = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  height: calc(41rem - 6rem);
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
  align-items: center;
`

export const ErrorWrap = styled.div`
  margin: 1.6rem 0 0;
  min-height: 3.6rem;
`

export const ErrorContent = styled.span`
  margin: 0;
  padding: 0.6rem 1rem;
  width: fit-content;
  display: flex;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.4rem;
  line-height: 1.67;
  letter-spacing: 0.06rem;
  color: ${(props) => props.theme.color.white};
  background-color: ${(props) => props.theme.color.danger};
  border-radius: 0.6rem;
  z-index: ${(props) => props.theme.zIndex.minimal};
  &::first-letter {
    text-transform: uppercase;
  }
`
